import React from 'react'

import { RoundButton } from 'elements/button/RoundButton'
import { AbsoluteDiv } from 'elements/layout/AbsoluteDiv'

import { ICON } from 'config/icons'

import { STEP_INPUT_IDS, type TConnectStep } from './constants'
import { focusInput } from './functions'

export type TPreviousConnectStepButtonProps = {
  solidPreviousButton?: boolean
  currentStep: TConnectStep
  goToStep: (step: TConnectStep) => Promise<void>
}

export const PreviousConnectStepButton: TFC<TPreviousConnectStepButtonProps> = ({
  solidPreviousButton,
  currentStep,
  goToStep,
}) =>
  currentStep !== 'email' ? (
    <AbsoluteDiv top="1em" left="1em" zIndex="zIndex1">
      <RoundButton
        onClick={() => {
          const nextStep = currentStep === 'password' ? 'email' : 'password'
          goToStep(nextStep)
          focusInput(STEP_INPUT_IDS[nextStep])
        }}
        type="button"
        icon={ICON.ARROW_LEFT}
        {...(solidPreviousButton && {
          colors: 'white',
          hoverColor: 'black',
          hoverBg: 'white',
          shadow: true,
        })}
      />
    </AbsoluteDiv>
  ) : null
